module.exports = __webpack_public_path__ + "img/Modernisme_Musikk3.9d554de1.jpg";